import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  updateNotificationTokenRequest: ["notificationToken"],
  updateNotificationTokenSuccess: ["status"],
  updateNotificationTokenFailure: null,
});

export const UpdateNotificationTokenTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  notificationToken: null,
  success: null,
  error: null,
  status: null,
});

export const UpdateNotificationTokenSelectors = {
  getData: (state: any) => state.updateNotificationToken.data,
  isFetching: (state: any) => state.updateNotificationToken.fetching,
  isSuccess: (state: any) => state.updateNotificationToken.success,
  hasError: (state: any) => state.updateNotificationToken.error,
};

export const request = (state: any, { notificationToken }: any) => {
  const updateData = {
    notificationToken: notificationToken,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPDATE_NOTIFICATION_TOKEN_REQUEST]: request,
  [Types.UPDATE_NOTIFICATION_TOKEN_SUCCESS]: success,
  [Types.UPDATE_NOTIFICATION_TOKEN_FAILURE]: failure,
});
